import React from 'react'

//Components 
import Multiselector from './Multiselector'
import DownloadChildNode from './DownloadChildNode'

//Styles
import styles from './DownloadContainer.module.scss' 

//Types
import { DownloadParentNode as ParentNodeType, DownloadChildNode as ChildNodeType } from 'types/download'

//Util
import {selectAll, unselectAll } from 'util/toc'


interface Props {
  node: ParentNodeType,
  handleChange: () => void
}

const DownloadParentNode = ({node, handleChange}: Props) => {

  const selectAllNodes = () => {
    selectAll(node.children || [])
    handleChange()
  }

  const unselectAllNodes = () => {
    unselectAll(node.children || [])
    handleChange()
  }

  return (
    <li>
      <label className={styles.parentLabel}>{node?.title}</label>
      { node.children && node.children.length > 1 ? <Multiselector selectAll={selectAllNodes} unselectAll={unselectAllNodes}/> : null }
      {
        node.children && node.children.length > 0 ? 
            <ul>
              {  
                node.children.map(childNode => {
                  let item
                  if (childNode.type === 'parent') {
                    let tocNode = childNode as ParentNodeType
                    item = <DownloadParentNode node={tocNode} key={tocNode.title} handleChange={handleChange}/>
                  } else if (childNode.type === 'include') {
                    let tocNode = childNode as ChildNodeType
                    item = <DownloadChildNode node={tocNode} key={`${tocNode.alias}_${tocNode.version}`} handleChange={handleChange}/>
                  } else {
                    item = null
                  }
                  return item
                })
              }
            </ul> : null
      }
    </li>
  )
}

export default DownloadParentNode